import { ExclamationCircleOutlined } from "@ant-design/icons";

export const ErrorMessage = ({ message }) => {
  return message ? (
    <div className="error-message poppins">
      <ExclamationCircleOutlined /> {message}
    </div>
  ) : null;
};
